export default __webpack_public_path__ + "static/media/saving.122ba418.png";